import { isFuture, isPast } from 'date-fns';

export function useFreezePeriod() {
  const { endDate: promoEndDate } = usePromos();
  const { endDate: presaleEndDate } = usePresale();

  return {
    isOnFreezePeriod: promoEndDate && isFuture(presaleEndDate) && isPast(promoEndDate),
    startDate: promoEndDate,
    endDate: presaleEndDate,
  };
}
